export default Form => props => (
  <div
    onSubmit={event => {
      event.stopPropagation?.();
    }}
  >
    <Form {...props} />
  </div>
);
